import EtnersCommonUtil from '@/common/etners.common.util'


const codeToText = function(solutionCodeMap, code) {
  if(code == undefined || code == "") {
    return code
  }

  if(solutionCodeMap[code] == undefined) {
    return code
  }

  return solutionCodeMap[code].cdNm
}

const commonCodeToText = function(commonCodeMap, code) {

  if(code == undefined || code == "") {
    return code
  }

  if(commonCodeMap[code] == undefined) {
    return code
  }

  return commonCodeMap[code].cdNm
}

const convertCodeGrupFormat = function(codeGrup, code) {

  if(EtnersCommonUtil.isEmpty(codeGrup) || EtnersCommonUtil.isEmpty(code)) {
    return code
  }

  let codeSplitArr = code.split('_')
  if (codeSplitArr.length == 1) {
    return codeGrup+'_'+code
  } else {
    return code
  }
}

const extractCodeFromCodeGrupFormat = function(codeGrupFormatCode) {
  if(EtnersCommonUtil.isEmpty(codeGrupFormatCode)) {
    return codeGrupFormatCode
  }

  let codeGrupFormatCodeSplitArr = codeGrupFormatCode.split('_')
  if(codeGrupFormatCodeSplitArr.length > 1) {
    return codeGrupFormatCodeSplitArr[1]
  } else {
    return codeGrupFormatCodeSplitArr[0]
  }
}

const convertYYYYMMDDFormat = function(yyyymmdd, separator) {
  if(yyyymmdd == undefined || yyyymmdd == "") {
    return yyyymmdd
  }

  if(separator == undefined) {
    separator = '/'
  }

  return `${yyyymmdd.substring(0, 4)}${separator}${yyyymmdd.substring(4, 6)}${separator}${yyyymmdd.substring(6, 8)}`
}

const convertHHMIFormat = function(hhmi) {
  if(hhmi == undefined || hhmi == "") {
    return hhmi
  }

  return hhmi.substring(0, 2) + ":" + hhmi.substring(2, 4)
}


const convertYYYYMMDDHHMIFormat = function(yyyymmddhhmi, separator) {
  if(yyyymmddhhmi == undefined || yyyymmddhhmi == "") {
    return yyyymmddhhmi
  }

  if(separator == undefined) {
    separator = '/'
  }

  return `${yyyymmddhhmi.substring(0, 4)}${separator}${yyyymmddhhmi.substring(4, 6)}${separator}${yyyymmddhhmi.substring(6, 8)} ${yyyymmddhhmi.substring(8, 10)}:${yyyymmddhhmi.substring(10, 12)}`

}
const solutionToText = function(solutionMap, solCd ,wbGbn) {

  if(solCd == undefined || solCd == "") {
    return solCd
  }

  if(solutionMap[solCd] == undefined) {
    return solCd
  }
  const findMap =  solutionMap[solCd] .find(function(v){return v.wmGbn === wbGbn})
  if(findMap === undefined){
    return solCd
  }

  return findMap.solNm
}
const superMenuIdToText = function(menuMap, code ,solCd ,wmGbn) {

  if (code === undefined || code === "") {
    return code
  }

  const superMenu = menuMap.find(function (v) {
    return v.menuMasterPK.menuId === code && v.menuMasterPK.solCd === solCd && v.menuMasterPK.wmGbn === wmGbn
  })

  if (superMenu === undefined || superMenu === "") {
    return code
  }
  return superMenu.menuNm
}


// Date 타입 객체를 String으로 format (YYYYMMDD)
const convertDateToStringYYYYMMDDFormat = function(date) {

  if(date == undefined || date == null || !(date instanceof Date)) {

    return date
  }

  let YYYY = date.getFullYear()
  let MM = date.getMonth()+1 < 10 ? "0"+(date.getMonth()+1) : (date.getMonth()+1).toString()
  let DD = date.getDate() < 10 ? "0"+date.getDate() : date.getDate().toString()

  return YYYY+MM+DD

}


const convertYYYYMMDDHHFormat = function (yyyymmddhh) {
  if(yyyymmddhh == undefined || yyyymmddhh == "") {
    return yyyymmddhh
  }
  if(yyyymmddhh.length < 10) {
    return yyyymmddhh
  }

  return yyyymmddhh.substring(0, 4) + '/' + yyyymmddhh.substring(4, 6) + '/' + yyyymmddhh.substring(6, 8) + ' ' + yyyymmddhh.substring(8, 10)
}

const convertYYYYMMDDHHMISSFormat = function (yyyymmddhhmiss) {
  if(yyyymmddhhmiss == undefined || yyyymmddhhmiss == '') {
    return yyyymmddhhmiss
  }
  if(yyyymmddhhmiss.length < 14) {
    return yyyymmddhhmiss
  }

  return yyyymmddhhmiss.substring(0, 4) + '/' + yyyymmddhhmiss.substring(4, 6) + '/' + yyyymmddhhmiss.substring(6, 8) + ' ' + yyyymmddhhmiss.substring(8, 10) + ':' + yyyymmddhhmiss.substring(10, 12) + ':' + yyyymmddhhmiss.substring(12, 14)
}
export default {
  codeToText,
  commonCodeToText,
  convertCodeGrupFormat,
  extractCodeFromCodeGrupFormat,
  convertYYYYMMDDFormat,
  convertYYYYMMDDHHMIFormat,
  convertHHMIFormat,
  solutionToText,
  superMenuIdToText,
  convertDateToStringYYYYMMDDFormat,
  convertYYYYMMDDHHFormat,
  convertYYYYMMDDHHMISSFormat
}
